import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  CanMatchFn,
  Route,
  Router,
  UrlTree,
} from '@angular/router';
import { AuthService } from '@Services/auth.service';
import { SecurityService } from '@Services/security.service';

function checkCustomization(route: ActivatedRouteSnapshot | Route): boolean | UrlTree {
  const authService = inject(AuthService);
  const security = inject(SecurityService);
  const router = inject(Router);

  // Admins always allowed
  if (authService.hasRealmRole('fsadmin')) {
    return true;
  }

  let allowed = true;
  const { data } = route;

  if (data?.customization != null) {
    allowed = security.checkCustomization(data.customization);
  }

  if (!allowed) {
    // Redirect to home if not allowed
    return router.createUrlTree(['/']);
  }

  return true;
}

export const customizationGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => checkCustomization(route);

export const customizationChildGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean | UrlTree => checkCustomization(route);

export const customizationMatchGuard: CanMatchFn = (route: Route): boolean | UrlTree => checkCustomization(route);
